<p-tabs
  scrollable
  value="0"
  class="engagementDash special-investments-tab"
  (onChange)="onTabChange($event)">
  <p-tablist>
    <p-tab value="0">Upload Template</p-tab>
    <p-tab value="1">Manage Template</p-tab>
    <p-tab value="2">History</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      <app-batch-upload-template></app-batch-upload-template>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-batch-manage-template
        [refreshData]="refreshData"></app-batch-manage-template>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-batch-history [refreshData]="refreshHistoryData"></app-batch-history>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
